import { createReducer } from '@reduxjs/toolkit'

import { defaultLanguage } from 'shared/locale'

import * as actions from '../actions'
import { IUserSettingsState } from '../types'

const initialState: IUserSettingsState = {
  data: {
    lang: defaultLanguage,
    isChanged: false,
  },
}

export default createReducer(initialState, builder => {
  builder.addCase(actions.changeLang.fulfilled, (state, action) => {
    state.data.lang = action.payload
    state.data.isChanged = true
  })
})
